/*----------------------------------
- LANDING: CONVERSION TRIGGER TRACKING
----------------------------------*/

import {
    buildConversionTriggerPayload,
    type ConversionTriggerId,
    type ConversionTriggerPayloadOverrides,
} from '@uniquedomains/components/contracts/analytics/conversionTriggers';
import { track } from '@/client/pages/landing/lib/analytics';

/*----------------------------------
- PUBLIC API
----------------------------------*/

export const trackConversionTrigger = (
    triggerId: ConversionTriggerId,
    overrides: ConversionTriggerPayloadOverrides = {},
) => {
    track('conversion_trigger_clicked', buildConversionTriggerPayload(triggerId, overrides));
};
